"use client";

import React from "react";

const DashboardPageClient: React.FC = () => {
  return (
    <div style={{ width: "100%", minHeight: "100vh" }}>
      <iframe
        title="外部控制台"
        src="https://www.wyjh.top/console"
        style={{ border: 0, width: "100%", height: "100vh" }}
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default DashboardPageClient;
